import { Injectable, computed, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class RefreshMenuService {
  data: any[] = [];

  #newMenu = signal<any[]>(this.data);
  newMenuData = computed(this.#newMenu);

  constructor() {}

  setNewMenu(newMenu) {
    this.#newMenu.set(newMenu);
  }
}
